import {
  RecommendedProduct,
  RecommendedProductsParams,
  RecommendedProductsResponse,
  useRecommendedProductsBySource,
} from './useRecommendedProductsShared'

const DESIGNS_HOOK_CONFIG = {
  source: 'designs' as const,
  fetchEventName: 'shop_design_recommendations_fetched' as const,
  section: 'from_your_designs' as const,
  fetchErrorNotification: 'Failed to fetch recommendations from designs',
  fetchErrorLogPrefix: 'Error fetching design recommendations',
}

export type { RecommendedProduct, RecommendedProductsParams, RecommendedProductsResponse }

export const useRecommendedProductsFromDesigns = (params: RecommendedProductsParams) =>
  useRecommendedProductsBySource(params, DESIGNS_HOOK_CONFIG)
